import { createContext, useContext, useState, ReactNode } from "react";

interface User {
  name: string;
  email: string;
  initials: string;
  hasBudget: boolean;
  budget: number;
  hasCredit: boolean;
  credit: number;
}

interface AuthContextType {
  isLoggedIn: boolean;
  user: User | null;
  login: (email: string, password: string) => boolean;
  logout: () => void;
}

const defaultUser: User = {
  name: "Ladislav Menyhart",
  email: "demo@merch.sk",
  initials: "LM",
  hasBudget: true,
  budget: 30.69,
  hasCredit: true,
  credit: 47.50,
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState<User | null>(null);

  const login = (email: string, password: string): boolean => {
    // Mock credentials check
    if (email === "demo@merch.sk" && password === "demo123") {
      setIsLoggedIn(true);
      setUser(defaultUser);
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
